// This file is automatically generated. Do not edit it directly.
import { createClient as supabaseCreateClient } from '@supabase/supabase-js';
import { Database } from './types';

// Use environment variables from .env file
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate required environment variables with better error handling
if (!SUPABASE_URL) {
  console.error('Missing VITE_SUPABASE_URL environment variable. Please check your .env file.');
  throw new Error('Missing VITE_SUPABASE_URL environment variable. Please check your .env file.');
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  console.error('Missing VITE_SUPABASE_ANON_KEY environment variable. Please check your .env file.');
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable. Please check your .env file.');
}

// Validate URL format
try {
  new URL(SUPABASE_URL);
} catch (error) {
  console.error('Invalid VITE_SUPABASE_URL format:', SUPABASE_URL);
  throw new Error('Invalid VITE_SUPABASE_URL format. Please provide a valid URL.');
}

// Validate key format (should start with 'ey' for JWT)
if (!SUPABASE_PUBLISHABLE_KEY.startsWith('ey')) {
  console.error('Invalid VITE_SUPABASE_ANON_KEY format:', SUPABASE_PUBLISHABLE_KEY.substring(0, 10) + '...');
  throw new Error('Invalid VITE_SUPABASE_ANON_KEY format. Please provide a valid Supabase anon key.');
}

/**
 * Creates a type-safe Supabase client with the project's Database type
 * This is exported for backward compatibility
 */
// No-op lock function that bypasses navigator.locks entirely.
// The default navigatorLock implementation hangs indefinitely on the
// production domain (intentdrive.ai), causing every supabase.from()
// call to never resolve. This was the root cause of the "Routers not
// loading" bug across 30+ attempted fixes over 2 days.
//
// Trade-off: concurrent tabs won't coordinate session refreshes as
// safely. Acceptable for our use case — sessions are short-lived and
// single-tab is the normal flow.
async function noOpLock(_name: string, _acquireTimeout: number, fn: () => Promise<any>) {
  return await fn();
}

export function createClient() {
  return supabaseCreateClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storageKey: 'supabase.auth.token',
      storage: window.localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      lock: noOpLock as any,
    }
  });
}

// Export a singleton instance for use throughout the app
export const supabase = createClient();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";